// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"BackToTop_buttonWrapper__1b8Vv","button":"BackToTop_button__172cQ"};